import React from "react";

interface CompassProps {
    className?: string;
}

const Compass: React.FC<CompassProps> = ({ className }) => {
    return (
        <svg className={className} viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg">
            <g id="color">
                <circle cx="36" cy="36" r="28" fill="#d22f27" />
                <polygon fill="#fff" points="36,20 30,36 36,40 42,36" stroke="none" />
            </g>
            <g id="line">
                <circle
                    cx="36"
                    cy="36"
                    r="28"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <circle
                    cx="36"
                    cy="36"
                    r="23"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <polygon
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    points="36,20 30,36 36,40 42,36"
                />
                <line
                    x1="36"
                    x2="36"
                    y1="8"
                    y2="13"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <line
                    x1="36"
                    x2="36"
                    y1="59"
                    y2="64"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <line
                    x1="64"
                    x2="59"
                    y1="36"
                    y2="36"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <line
                    x1="13"
                    x2="8"
                    y1="36"
                    y2="36"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    d="M36,15v3 M36,54v3"
                />
                <path
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                    d="M57,36h-3 M18,36h-3"
                />
            </g>
        </svg>
    );
};

export default Compass;
